import { render, staticRenderFns } from "./ButtonSetAlternateAction.vue?vue&type=template&id=15c3d406&"
import script from "./ButtonSetAlternateAction.vue?vue&type=script&lang=js&"
export * from "./ButtonSetAlternateAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports